import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import _get from "lodash/get";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function responseDataParser(data) {
  return _get(data, 'data');
}

function responseHandler(resolve, reject, options, serverRequest) {
  var dataParser = _get(options, 'dataParser', responseDataParser);

  return function (err, resp, data) {
    var statusCode = !err && _get(resp, 'statusCode');

    if (!err && statusCode >= 200 && statusCode < 300) {
      resolve(dataParser(data, resp));
    } else {
      // This is super raw, but until we form stronger opinions about how we handle errors on
      // the FE, this is the most flexible solution.
      if (typeof window === 'undefined' && serverRequest && _get(resp, 'statusCode') >= 500) {
        var method = _get(resp, 'request.method');

        var href = _get(resp, 'request.href');

        serverRequest.log.error("".concat(method, " ").concat(href, " returned a ").concat(_get(resp, 'statusCode')));
      }

      reject({
        err: err,
        resp: resp,
        data: data
      });
    }
  };
}

export default function (ServiceSDK, routeBuilder, handlerOptions) {
  return {
    get: function get(endpoint, params, serverRequest, config) {
      return new Promise(function (resolve, reject) {
        ServiceSDK.get(routeBuilder(endpoint), params, responseHandler(resolve, reject, _objectSpread({}, handlerOptions, config), serverRequest), serverRequest, config);
      });
    },
    post: function post(endpoint, data, serverRequest, config) {
      return new Promise(function (resolve, reject) {
        ServiceSDK.post(routeBuilder(endpoint), data, responseHandler(resolve, reject, _objectSpread({}, handlerOptions, config), serverRequest), serverRequest, config);
      });
    },
    put: function put(endpoint, data, serverRequest, config) {
      return new Promise(function (resolve, reject) {
        ServiceSDK.put(routeBuilder(endpoint), data, responseHandler(resolve, reject, _objectSpread({}, handlerOptions, config), serverRequest), serverRequest, config);
      });
    },
    patch: function patch(endpoint, data, serverRequest, config) {
      return new Promise(function (resolve, reject) {
        ServiceSDK.patch(routeBuilder(endpoint), data, responseHandler(resolve, reject, _objectSpread({}, handlerOptions, config), serverRequest), serverRequest, config);
      });
    },
    delete: function _delete(endpoint, data, serverRequest, config) {
      return new Promise(function (resolve, reject) {
        ServiceSDK.del(routeBuilder(endpoint), data, responseHandler(resolve, reject, _objectSpread({}, handlerOptions, config), serverRequest), serverRequest, config);
      });
    }
  };
}